module.exports = __webpack_public_path__ + "img/logo.55d41508.png";